import { TypographyProps } from "@mui/material";

export const OVERFLOW_SX: Readonly<TypographyProps["sx"]> = {
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap",
};
